/**
 * One place for billing-period wording across the Sites dashboard (plans,
 * transactions, previews). Paywall / castr products carry `period` as
 * `day | week | month | year` (paywall `periodValues`); recurring invoices
 * repeat it. Nothing here builds words by concatenation ("dayly").
 */
export const PERIODS = ['day', 'week', 'month', 'year']

const ADVERB = { day: 'daily', week: 'weekly', month: 'monthly', year: 'yearly' }
const NOUN = { day: 'day', week: 'week', month: 'month', year: 'year' }

/** Plan modal "Billing interval" options. */
export const PERIOD_OPTIONS = PERIODS.map((value) => ({ value, text: ADVERB[value][0].toUpperCase() + ADVERB[value].slice(1) }))

export function normalizePeriod(period) {
	const p = String(period || '').toLowerCase()
	return PERIODS.includes(p) ? p : 'month'
}

/** Singular / plural noun: `periodNoun('week', 2)` → "weeks". */
export function periodNoun(period, count = 1) {
	const noun = NOUN[normalizePeriod(period)]
	return Number(count) === 1 ? noun : `${noun}s`
}

/** "daily" · "monthly" · with a count > 1: "every 2 weeks". */
export function periodAdverb(period, count = 1) {
	const p = normalizePeriod(period)
	const n = Number(count) || 1
	return n === 1 ? ADVERB[p] : `every ${n} ${periodNoun(p, n)}`
}

/** Suffix after a price: "/ month" · "/ 2 weeks". */
export function periodSuffix(period, count = 1) {
	const n = Number(count) || 1
	return n === 1 ? `/ ${periodNoun(period, 1)}` : `/ ${n} ${periodNoun(period, n)}`
}

/** Billing line for a recurring purchase: "Renews daily"; one-time → "One-time". */
export function billingLabel({ recurring, period, count } = {}) {
	if (!recurring) return 'One-time'
	return `Renews ${periodAdverb(period, count)}`
}
